export default {
  range: {
    cursor: 'pointer',
    width: '100%',
    height: '30px',
  },
  label: {
    width: '100%',
    height: '60px',
    position: 'relative',
  },
  inner: {
    margin: '0 20px 0 20px',
    height: '20px',
    position: 'relative',
  },

  track: {
    position: 'absolute',
    width: '100%',
    height: '8px',
    borderRadius: '0px',
    top: '9px',
    left: '0',
  },
  trackFill: {
    position: 'absolute',
    width: '0',
    height: '8px',
    borderRadius: '0px',
    top: '9px',
    left: '0',
  },
  thumb: {
    position: 'absolute',
    top: '0',
    left: '0',
    height: '20px',
    width: '10px',
  },
  valueMin: {
    position: 'absolute',
    bottom: '-22px',
    left: '-5px',
  },
  valueMax: {
    position: 'absolute',
    bottom: '-22px',
    right: '-5px',
  },
  line: {
    position: 'absolute',
    top: '0',
    height: '20px',
    width: '2px',
  },
  thumbDisplay: {
    height: '60px',
    lineHeight: '55px',
    fontSize: '1.5em',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  thumbDisplayInput: {
    width: '100px',
    right: '0px',
    textAlign: 'right',
    border: 'none',
    outline: 0,
    backgroundColor: 'inherit',
    color: 'inherit',
  },
  thumbDisplayUnit: {
    alignSelf: 'center',
    width: '80px',
    textAlign: 'left',
    paddingLeft: '1rem',
  },
  /*--------------
  Disabled
---------------*/
  disabled: {
    cursor: 'auto',
    opacity: '.5',
  },
  disabledTrackFill: {
    background: '#ccc',
  },
};
